import React, { useState } from 'react';
import { VStack, Text, Flex, Button, Center } from '@televet/kibble-ui';
import { PhoneCallParticipantEvent } from 'shared/providers/PhoneCallProvider/interfaces/PhoneCallParticipantEvent';
import PhoneCallParticipantEventItem from './PhoneCallParticipantEventItem';

interface CallParticipantEventProps {
  label: string;
  description: string;
  emptyStateText: string;
  events: PhoneCallParticipantEvent[];
}

const PhoneCallParticipantEventList = ({
  label,
  description,
  emptyStateText,
  events,
}: CallParticipantEventProps): JSX.Element => {
  const [isListExpanded, setIsListExpanded] = useState(false);
  return (
    <VStack align="stretch" spacing={2} px={4}>
      <Flex justify="space-between" align="baseline">
        <Text fontWeight="semibold" size="md">
          {label}
        </Text>
        <Text variant="subtle" fontWeight="normal" size="xs">
          {description}
        </Text>
      </Flex>

      {events.length ? (
        events
          .slice(0, isListExpanded ? undefined : 2)
          .map((event, index) => <PhoneCallParticipantEventItem key={index} event={event} isHistory />)
      ) : (
        <Text variant="subtle">{emptyStateText}</Text>
      )}
      {events.length > 2 && (
        <Center>
          <Button variant="tertiary" size="xs" onClick={(): void => setIsListExpanded((value) => !value)}>
            {isListExpanded ? 'Hide' : 'Show'} more
          </Button>
        </Center>
      )}
    </VStack>
  );
};

export default PhoneCallParticipantEventList;
